export const serverUrlInputFieldTooltip =
  "The server must have the Inery chain API installed";
